import {AuthService} from "./AuthService";

export class DynamicPricingAuditService {
    url = `dynamic_pricing_audit/`;

    // params: {campaign_id, scope, actor_email, target_id, start_date, end_date, limit, offset}
    // target_id scopes the listing to one entity's own records -- e.g. the
    // product detail page's history view filters to that product's id.
    list(params) {
        return AuthService.apiGet(this.url, {params: params}).then(res => res.data.data);
    }

    actors(campaignId) {
        return AuthService.apiGet(this.url + "actors/", {
            params: campaignId ? {campaign_id: campaignId} : {}
        }).then(res => res.data.data);
    }
}
